import { useState } from 'react';
import useApi from '@/lib/api/useApi';
import useIsPortfolioReadOnly from '@/components/ChallengePortfolio/NormalView/useIsPortfolioReadonly';
import useRubricsPortfolioApiEndpoint from '../../useRubricsPortfolioApiEndpoint';

const useMarkCoachCommentsAsRead = (levelId: number): (() => void) => {
  const api = useApi();
  const rubricsPortfolioApiEndpoint = useRubricsPortfolioApiEndpoint();

  const portfolioIsReadonly = useIsPortfolioReadOnly();
  const [markedAsRead, setMarkedAsRead] = useState(false);

  const markCoachCommentsAsRead = (): void => {
    if (markedAsRead || portfolioIsReadonly) {
      return;
    }

    setMarkedAsRead(true);

    api.post(
      `${rubricsPortfolioApiEndpoint}/level-progress-coach-comments/${levelId}/read`,
    );
  };

  return markCoachCommentsAsRead;
};

export default useMarkCoachCommentsAsRead;
